import { FC } from 'react'

import { SlideItemProps } from './constants'
import {
  Body,
  QrCode,
  QrTitle,
  QrWrapper,
  StoreBtnWrapper,
  Subtitle,
  Title,
  TitleWrapper,
} from './style'

import { DesktopView, MobileView, StoreBtn } from './index'

interface MobileAppBodyProps {
  title: string
  subTitle: string
  qrTitle: string
  qrCode: string
  slideItems: SlideItemProps[]
  titleLetterSpacing?: number
  setIsFixed: (arg: number) => void
}

const MobileAppBody: FC<MobileAppBodyProps> = ({
  title,
  subTitle,
  qrTitle,
  qrCode,
  titleLetterSpacing,
  slideItems,
  setIsFixed,
}) => {
  return (
    <Body>
      <TitleWrapper>
        <Title titleLetterSpacing={titleLetterSpacing}>{title}</Title>
        <Subtitle>{subTitle}</Subtitle>
        <QrWrapper>
          <QrTitle>{qrTitle}</QrTitle>
          <QrCode>
            {/* TODO: Fix this auto-generated suppression. */}
            {/* eslint-disable-next-line @next/next/no-img-element, rulesdir/require-responsive-images */}
            <img src={qrCode} alt='qr code' width='100%' />
          </QrCode>
        </QrWrapper>
        <StoreBtnWrapper>
          <StoreBtn />
        </StoreBtnWrapper>
      </TitleWrapper>
      <DesktopView slideItems={slideItems} setIsFixed={setIsFixed} />
      <MobileView slideItems={slideItems} />
    </Body>
  )
}

export default MobileAppBody
